import { css } from '@emotion/react'
import "focus-visible/dist/focus-visible"

import { mediaStyle } from './src/contexts/responsive'

export default css`
  @import url('https://fonts.googleapis.com/css2?family=Crimson+Text:wght@400;600;700&family=Noto+Sans+TC:wght@300;400;500;700;900&display=swap');
  body {
    min-width: 100%;
    min-height: 100%;
  }

  @Media screen and (min-width: 772px) {
    body {
      font-size: calc(min(100vw, 1920px) / 120);
    }
  }

  ${mediaStyle}
`;
